import React from 'react'
import { useLocation } from 'react-router-dom'

const Footer = () => {
  const location = useLocation()
  
  // Hide footer on chat page for better UX - chat interface needs full screen
  const isChatPage = location.pathname.includes('/chat')
  const currentYear = new Date().getFullYear();

  if (isChatPage) {
    return null
  }
 
  return (
    <footer className="z-3 main-footer" role="row">
    <div className="pull-right hidden-xs">
      <b>Version</b> 1.0 &nbsp;&nbsp;&nbsp;
      <strong role="contentinfo">Copyright &copy; {currentYear} <span  className="foot-link">Caretap</span></strong>
    </div>
    </footer>
  )
}

export default React.memo(Footer)
